import React from "react";

const TermOfService = () => {
  return <section className="py-5 fw-semibold">Term Of Services...</section>;
};

export default TermOfService;
